export var HumanTaskTagCategory;
(function (HumanTaskTagCategory) {
    HumanTaskTagCategory["HumanTask"] = "HumanTask";
})(HumanTaskTagCategory || (HumanTaskTagCategory = {}));
//# sourceMappingURL=tagCategory.js.map